import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  ref: "actionsModal",
  class: "modal fade",
  id: "actionsModal",
  tabindex: "-1",
  "aria-labelledby": "actionsModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content rounded-2" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = { class: "modal-body text-start" }
const _hoisted_7 = {
  id: "userPills",
  class: "mb-3"
}
const _hoisted_8 = { class: "fs-6 fw-semibold" }
const _hoisted_9 = {
  key: 0,
  class: "d-flex gap-2 flex-wrap align-content-start mt-2"
}
const _hoisted_10 = ["index"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "form-text text-danger" }, " No users selected. Please select users to perform this action. ", -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  class: "mb-3",
  ref: "subject"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  for: "subject",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("small", { class: "fs-6 fw-semibold" }, "Subject")
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  class: "form-control rounded-0",
  id: "subject",
  placeholder: "Specify what your warning is about"
}, null, -1)
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = {
  class: "mb-3",
  ref: "description"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  for: "description",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("small", { class: "fs-6 fw-semibold" }, "Description")
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("textarea", {
  type: "text",
  class: "form-control rounded-0",
  id: "description",
  rows: "4",
  placeholder: "Write a decriptive warning message for these users."
}, null, -1)
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "form-text mb-3" }
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { class: "form-text mb-3" }
const _hoisted_27 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserTag = _resolveComponent("UserTag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.action !== "Delete" ? `${_ctx.action} Users` : `${_ctx.action} Accounts`), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "aria-label": "Close",
            "data-bs-dismiss": "modal",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("form", null, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("small", _hoisted_8, _toDisplayString(`Users to ${_ctx.action}`), 1),
              (_ctx.selectedUsers.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedUsers, (user, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        id: "userList",
                        key: user.id,
                        index: index
                      }, [
                        _createVNode(_component_UserTag, {
                          id: `userTag-${index}`,
                          userId: user.id,
                          name: user.name,
                          onRemoveSelected: _ctx.onRemoveSelected
                        }, null, 8, ["id", "userId", "name", "onRemoveSelected"])
                      ], 8, _hoisted_10))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
            ]),
            (_ctx.action === 'Warn')
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, _hoisted_18, 512),
                  _createElementVNode("div", _hoisted_19, _hoisted_22, 512)
                ]))
              : (_ctx.action === 'Suspend')
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _withDirectives(_createElementVNode("div", _hoisted_24, " Please confirm if you would like to suspend the accounts of these users. ", 512), [
                      [_vShow, _ctx.selectedUsers.length > 0]
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _withDirectives(_createElementVNode("div", _hoisted_26, " Please confirm if you would like to delete the accounts of these users. ", 512), [
                      [_vShow, _ctx.selectedUsers.length > 0]
                    ])
                  ]))
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["btn btn-danger rounded-0 p-2", _ctx.selectedUsers.length === 0 ? 'disabled' : ''])
          }, _toDisplayString(_ctx.action), 3),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-dark rounded-0 p-2",
            "data-bs-dismiss": "modal",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancelAction && _ctx.cancelAction(...args)))
          }, " Cancel ")
        ])
      ])
    ])
  ], 512))
}